<script>
import {colorNames} from "./colorNames"
export let settings = null
export let key = null

let isSet = settings !== null && key !== null && (key in settings.style) && settings.style[key] != "unset"
let isNamed = isSet ? (settings.style[key] in colorNames) : false
let hex = isNamed ? colorNames[settings.style[key]] : isSet ? settings.style[key].substring(0,7) : "#FFFFFF"
let hasOpacity = isSet && !isNamed ? settings.style[key].length > 6 : false
let opacity = isSet && hasOpacity ? parseInt(settings.style[key].substring(7), 16) / 255 : 1.0

$: {
    let opacityEnding = Math.round(opacity * 255).toString(16)
    let trueValue = hex + opacityEnding

    if (isSet) {
        settings.style[key] = trueValue
    } else {
        settings.style[key] = "unset"
    }
}

</script>

<div class="input-wrap">
    {#if isSet}
        <input type="range" bind:value={opacity} min="0" max="1" step = "0.01"  id = "opacity">
        <input type="number" bind:value={opacity} min="0" max="1" step = "0.01"  id = "opacity">
        <input type="color" bind:value={hex}/>
    {/if}
    <input type="checkbox" bind:checked={isSet}/>
</div>


<style>

.input-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

input[type=color] {
    padding: 0px;
    height: 24px;
    width: 24px;
    background-color: rgba(0,0,0,0);
    border-radius: 20px;
}

input {
    outline: none;
    border: none;
    margin: 0px;
    padding: 0px;
    margin-left: 10px;
}

input[type=text] {
    text-align: right;
    background-color: rgba(0,0,0,0);
}

input[type=range] {
    width: 75px;
}

</style>